import { ASSET_PATHS } from '../../utils/assetPath';

import './LocationIcon.css';

interface LocationIconProps {
  /**
   * Additional CSS class names
   */
  className?: string;
  /**
   * Size of the icon in pixels
   */
  size?: number;
  /**
   * Aria label for accessibility
   */
  ariaLabel?: string;
}

/**
 * LocationIcon component
 *
 * Displays a location icon using the SVG from the public folder.
 * Used to indicate the current step in the application status tracker.
 *
 * @example
 * <LocationIcon />
 * <LocationIcon size={32} ariaLabel="Current step" />
 */
function LocationIcon({ className = '', size = 32, ariaLabel = 'Current location' }: LocationIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`location-icon ${className}`}
      height={size}
      src={ASSET_PATHS.LOCATION_ICON}
      width={size}
    />
  );
}

export default LocationIcon;
